import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

const Funeral = () => {
    const phoneNumber = '918800864674'; // Your number here

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };
  
  return (
    <>
      <Helmet>
        <title>Pet Funeral Services | PetCrew</title>
        <meta name="description" content="Dignified pet funeral and cremation services by PetCrew. We help you say goodbye with care and respect." />
        <meta name="keywords" content="pet funeral, pet cremation, pet last rites, pet memorial, PetCrew funeral services" />
      </Helmet>

      <Header />

      <div className="container funeral-container">
        <div className="funeral-content">
          <h1>Pet Funeral Services</h1>
          <p>
            Losing a beloved pet is never easy. At PetCrew, we provide compassionate and respectful funeral and cremation services to help you say goodbye with dignity. From pickup to final rites, we’re here to support you through this time.
          </p>
          <ul>
            <li>Pet pickup and transportation</li>
            <li>Individual or group cremation options</li>
            <li>Memorial certificates</li>
            <li>Custom urns and ashes return</li>
          </ul>

          <div className="funeral-button">
            <button onClick={handleClick} className="btn">Call for Funeral</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Funeral;
